const RETURN_REQUEST_TAG = "Rental: Return Requested";

function getNestedRentalItems(order = {}) {
  const directItems = Array.isArray(order?.rentalLines) ? order.rentalLines : [];
  const fallbackItems = Array.isArray(order?.items) ? order.items : [];
  return directItems.length ? directItems : fallbackItems;
}

export function isPendingReturnOrder(order = {}) {
  if (order?.pendingApproval === true) {
    return true;
  }

  const status = String(order?.status || order?.statusLabel || "").trim().toLowerCase();
  if (status === "return requested") return true;

  const tags = Array.isArray(order?.tags) ? order.tags : [];
  const hasPendingTag = tags.some(
    (tag) => String(tag || "").trim().toLowerCase() === RETURN_REQUEST_TAG.toLowerCase(),
  );
  const hasApprovedTag = tags.some(
    (tag) => String(tag || "").trim().toLowerCase() === "rental: return",
  );
  const hasRejectedTag = tags.some(
    (tag) => String(tag || "").trim().toLowerCase() === "rental: rejected",
  );

  const hasReturnMetadata =
    String(order?.returnReason || "").trim() || String(order?.returnRequestedAt || "").trim();
  const hasPendingQuantity =
    Number(order?.returnRequestedQuantity || order?.returnQuantity || order?.returnedQuantity) > 0;
  const hasFinalStatus = status === "return" || status === "rejected" || status === "closed";
  const hasNestedReturnSignal = getNestedRentalItems(order).some((item) => {
    const itemStatus = String(item?.status || item?.statusLabel || "").trim().toLowerCase();
    if (itemStatus === "return requested") return true;

    const itemMetadata =
      String(item?.returnReason || item?.return_reason || "").trim() ||
      String(item?.returnRequestedAt || item?.return_requested_at || "").trim();
    const itemQuantity =
      Number(item?.returnRequestedQuantity || item?.returnQuantity || item?.returnedQuantity) > 0;

    return Boolean(itemMetadata || itemQuantity);
  });

  if (hasRejectedTag) return false;
  if (hasApprovedTag && !hasPendingTag && !hasReturnMetadata && !hasPendingQuantity && !hasNestedReturnSignal) {
    return false;
  }
  if (hasFinalStatus && !hasPendingTag && !hasReturnMetadata && !hasPendingQuantity && !hasNestedReturnSignal) {
    return false;
  }

  return Boolean(hasPendingTag || hasReturnMetadata || hasPendingQuantity || hasNestedReturnSignal);
}
